import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { DashBoardApiService } from 'features/Dashboard/api/dashboard-api.service';

const { uploadImageDocument } = DashBoardApiService();

export const useUploadImage = () => {
  const { message } = App.useApp();

  return useMutation<
    { rs: number },
    unknown,
    { id: string; formData: FormData }
  >(({ id, formData }) => uploadImageDocument(id, formData), {
    onError: (error) => {
      const uiMessage = handleError(error);
      message.error(uiMessage);
    },
    onSuccess: (data) => {
      if (data) {
        message.success('Upload Image successfully');
      }
    },
  });
};
